import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";
import React from "react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { LuBrain } from "react-icons/lu";
import { Input, Spinner, Button, Dropdown, DarkPopover, ButtonColor, ButtonVariant } from "@swivl-mono/ui";
import { BrainsModel } from "../../../../../Models/Brains/Brains.Model";
import { WorkflowsJourney, QuestsModel } from "../../../../../Models/Quests/Quests.Model";

import { InheritanceStatus } from "@swivl-mono/types";

interface Props {
  workflowJourney: WorkflowsJourney;
  isDragging: boolean;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
  isDragDisabled: boolean;
}

export default function BoardJourneyHeader({ workflowJourney, dragHandleProps, isDragging }: Props) {
  const { brains } = BrainsModel.useState((s) => s);

  const [showMenu, setShowMenu] = React.useState(false);
  const [isEditing, setIsEditing] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const name = workflowJourney.isUnassignedGroup ? "Unassigned" : workflowJourney?.journey?.name;
  const [newName, setNewName] = React.useState(name);

  const saveName = async () => {
    if (!workflowJourney.journey) return;
    setIsSaving(true);

    let journey = { ...workflowJourney.journey };
    journey.name = newName!
    await QuestsModel.updateJourney(journey, true);
    setIsSaving(false);
    setIsEditing(false);
  };

  const optionSelectedMethod = async (option: any) => {
    if (!workflowJourney.journey) return;
    setIsSaving(true);

    let journey = { ...workflowJourney }.journey!;
    if (option.value === undefined) {
      journey.brainSlug = undefined;
    } else {
      journey.brainSlug = option.value;
    }
    await QuestsModel.updateJourney(journey, true);
    setIsSaving(false);

    // setIsEditing(false)
  };

  let brainOptions: any;
  if (isEditing && brains) {
    brainOptions = brains.map((i) => {
      return { value: i.slug, label: i.name };
    });
    brainOptions.unshift({ value: undefined, label: "Not Set" });
  }



  return (
    <div
      className={`JourneyHeader ${isDragging ? "isDragging" : ""}  ${showMenu ? "showMenu" : ""} ${isEditing ? "isEditing" : ""}`}
      {...dragHandleProps}
    >
      {isEditing ? (
        <div className="EditView">
          <Input
            value={newName}
            onChange={(e) => {
              setNewName(e.target.value);
            }}
          />
          <div className="editViewButtons">
            {isSaving ? (
              <Spinner />
            ) : (
              <>
                <Button variant={ButtonVariant.GHOST} onClick={() => setIsEditing(false)}>Cancel</Button>
                <Button color={ButtonColor.ORANGE} onClick={saveName}>
                  Save
                </Button>
              </>
            )}
          </div>

          {isEditing ? (
            <div className="selectJourneyBrain">
              <label>
                <LuBrain /> BRAIN
              </label>
              {brains ? (
                <Dropdown
                  options={brainOptions}
                  value={workflowJourney?.journey?.brainSlug}
                  name={"brainSlug"}
                  optionSelected={optionSelectedMethod}
                  showSearch={true}
                  stayAtTopOnOpen={true}
                />
              ) : (
                <Spinner />
              )}
            </div>
          ) : null}
        </div>
      ) : (
        <div className="Wrapper">
          <div className="JourneyName">
            {" "}
            {workflowJourney.journey?.brainSlug && <LuBrain />} {name}{" "}
          </div>

          {(!workflowJourney?.journey?.inheritance || workflowJourney?.journey?.inheritance !== InheritanceStatus.NONE) && (
            <div
              className="MenuButton"
              onClick={() => {
                setShowMenu(!showMenu);
              }}
            >
              <BiDotsVerticalRounded size={18} />
              {showMenu && (
                <DarkPopover
                  top={20}
                  clickedOutside={() => {
                    setShowMenu(false);
                  }}
                >
                  <a onClick={() => setIsEditing(true)}>
                    <b>Edit</b>
                  </a>
                  <a
                    onClick={() => {
                      if (window.confirm("Are you sure you want to delete this journey?")) {
                        QuestsModel.deleteJourney(workflowJourney.journey!);
                      }
                    }}
                  >
                    <b>Delete</b> journey
                  </a>
                </DarkPopover>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
